/**	
 * External dependencies.
 */
import $ from 'jquery';

/**
 * Search form hide label. 
 */
$('.js-search-form input').on('input', function(){
	const $this = $(this);
	const label = $this.parent();
	
	if ( $this.val() != '' ) {
		label.addClass('is-active');
	} else {
		label.removeClass('is-active');
	}
});
